import { generateModeCss } from "../config/generateModeCss";

const MODE_CSS = generateModeCss();

export function ModeStyle() {
  return <style>{MODE_CSS}</style>;
}
